import { useMutation } from '@tanstack/react-query'
import { updateApprovers } from 'services/ApprovalsService'

export const useManageApproversMutation = () => {
  return useMutation({ mutationFn: updateApprovers })
}
